import PropTypes from 'prop-types';

const propType = {
  _id: PropTypes.string,
  name: PropTypes.string,
  createdAt: PropTypes.number,
  updatedAt: PropTypes.number,
  price: PropTypes.number,
  userPrice: PropTypes.object,
  userClickAndCollectPrice: PropTypes.object,
  translations: PropTypes.object,
};

export default { propType };
